import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import Planet from '../gameItems/Planet';
import Popup from '../gameItems/Popup';
import Rocket from '../gameItems/Rocket';
import FontKeys from '../FontKeys';

export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    preload()
    {
        // preload your assets here, if needed
        this.anims.create({ key: 'burn', frames: this.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, { start: 0, end: 15, prefix: 'flames_v2_' }), frameRate: 64, repeat: -1 });
    }

    create()
    {
        gameData.GAME_STATE = "intro";
        gameData.WORDS_MISSED = 0;
        gameData.GAME_PAUSED = false;

        this.flames = [];

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        ABCyaPhaser.Audio.playOneShot("Jingle_Typing_Rock", this, .3, true);

        this.bgCont = this.add.container(this.mid.x, this.mid.y);
        this.navCont = this.add.container();

        const key = "bgIntro";

        this.bg = ABCyaPhaser.Images.addImage(0, 0, null, this.bgCont, key);
        this.bg2 = ABCyaPhaser.Images.addImage(this.bg.width - 3, 0, null, this.bgCont, key);
        this.start = ABCyaPhaser.Text.addText(0, 0, 52, 0xffd493, FontKeys._neuropolregular, ABCyaPhaser.Localization.instance.getLocalizedString('start'), this.navCont);

        this.playBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "introPlay", null, ()=>{
            this.playBtn.setEnabled(false);
            this.flyOut();
        }, this.navCont).setEnabled(false);

        this.planet = new Planet(this);
        this.rocket = new Rocket(this);

        this.rocket.setScale(.8);

        this.skyTweenIn();
        this.createNav();
    };

    skyTweenIn(){
        this.bgCont.x = 0;

        this.bgTween = ABCyaPhaser.Tweens.addTween(this.bgCont, 40000, {x:-this.bg.width}, Phaser.Math.Easing.Linear, ()=>{
            this.skyTweenIn();
        });
    };

    showPopup(){
        ABCyaPhaser.Audio.playOneShot("Click", this);

        this.popup = new Popup(this, "intro");
     };

    createNav(){
        //create the navigation and title
        const spacer = 20;

        this.start.x = -this.start.width/2 - spacer/2;
        this.playBtn.x = this.playBtn.width/2 + spacer/2;
        this.navCont.x = this.mid.x*2 - this.playBtn.width - spacer*2;
        this.navCont.y = this.mid.y*2 - this.navCont.height/2 - spacer*3;
        this.navCont.alpha = 0;
        this.playBtn.scaleX = this.playBtn.scaleY = 0;

        ABCyaPhaser.Tweens.addTween(this.navCont, 1000, {alpha:1, delay:2000}, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(this.playBtn, 1000, {scale:1, delay:2000}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.playBtn.setEnabled(true);
        });
    };

    flyOut(){
        // console.log("flying out");
        this.tweens.killTweensOf(this.bgCont);
        this.tweens.killTweensOf(this.rocket);

        this.planet.tweenOut();
        
        ABCyaPhaser.Tweens.addTween(this.navCont, 250, {alpha:0}, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(this.rocket, 750, {x:this.mid.x*2 + this.rocket.width*2 + 200, angle:15}, Phaser.Math.Easing.Linear);

        this.showPopup();
    };

    destroyIntro(){
        // console.log("destroying Intro");

        this.sound.stopAll();
        this.tweens.killAll();

        if(this.rocket){
            this.rocket.destroyRocket();
            this.rocket.destroy();
            this.rocket = null;
        }

        this.planet.destroy();

        this.scene.start("Game");
    };
}